(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  function getSectionRoot(el) {
    return el?.closest('[id^="shopify-section-"]') || document;
  }

  function buildVariantIndex() {
    const i = new Map();
    const s = $$('script[type="application/json"][id^="variants-json-"],script[type="application/json"][data-variants-json]');
    s.forEach(sc => {
      const sec = getSectionRoot(sc);
      let l = [];
      try { l = JSON.parse(sc.textContent || '[]'); } catch {}
      l.forEach(v => v?.id && i.set(String(v.id), { v, sec }));
    });
    return i;
  }

  function writeOptionLabels(sec, v) {
    if (!v?.options) return;
    const spans = $$('[data-option-value]', sec);
    spans.forEach((sp, i) => v.options[i] != null && (sp.textContent = v.options[i]));
  }

  function applyFromUrl(idx) {
    const id = new URL(location.href).searchParams.get('variant');
    if (!id) return;
    const m = idx || buildVariantIndex();
    const h = m.get(String(id));
    if (!h) return;
    writeOptionLabels(h.sec, h.v);
    document.dispatchEvent(new CustomEvent('labels:variant-updated', { detail: { variant: h.v } }));
  }

  function hookHistory(fn) {
    const p = history.pushState, r = history.replaceState;
    history.pushState = function () { const x = p.apply(this, arguments); try { fn(); } catch {} return x; };
    history.replaceState = function () { const x = r.apply(this, arguments); try { fn(); } catch {} return x; };
    addEventListener('popstate', () => { try { fn(); } catch {} });
  }

  let idx = null;
  function rebuild() { idx = buildVariantIndex(); applyFromUrl(idx); }

  document.readyState === 'loading'
    ? addEventListener('DOMContentLoaded', rebuild)
    : rebuild();

  hookHistory(() => applyFromUrl(idx));

  if (window.MutationObserver) {
    let raf = 0;
    new MutationObserver(m => {
      const hit = m.some(x =>
        [...(x.addedNodes || [])].some(n =>
          n.nodeType === 1 &&
          n.matches?.('script[type="application/json"][id^="variants-json-"],script[type="application/json"][data-variants-json]')
        )
      );
      if (hit) {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(rebuild);
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
